import React from "react";
import { TextInput as Inpt, Tooltip } from "@mantine/core";

const TextInput = (
  {
    readOnly,
    disabled,
    onBlur,
    error,
    icon,
    iconWidth,
    invalid,
    multiline,
    pointer,
    radius,
    required,
    rightSection,
    size = "md",
    variant,
    withAsterisk,
    form,
    validateName,
    label,
    placeholder,
    type = "text",
    p,
    py,
    px,
    pt,
    pb,
    pl,
    pr,
    m,
    my,
    mx,
    mt = "xs",
    mb,
    ml,
    mr,
    padding = "1.4rem 0.75rem",
    onChange,
    value,
    mask,
    component,
    onInput,
    styles,
    color,
    description,
    toolTipLabel,
    defaultValue,
    ...props
  },
  ref,
) => {
  if (toolTipLabel) {
    return (
      <Tooltip label={toolTipLabel} color="blue" withArrow>
        <Inpt
          //increase internal padding
          styles={{
            input: {
              padding: { padding },
            },
            ...styles,
          }}
          readOnly={readOnly}
          color={color}
          description={description}
          pt={pt}
          p={p}
          m={m}
          component={component}
          mask={mask}
          value={value}
          onChange={onChange}
          type={type}
          mt={mt}
          placeholder={placeholder}
          label={label}
          disabled={disabled}
          icon={icon}
          iconWidth={iconWidth}
          invalid={invalid}
          multiline={multiline}
          pointer={pointer}
          radius={radius}
          required={required}
          rightSection={rightSection}
          size={size}
          variant={variant}
          withAsterisk={withAsterisk}
          onInput={onInput}
          onWheel={(e) => e.target.blur()}
          {...form?.getInputProps(validateName, {})}
          defaultValue={defaultValue}
          {...props}
        />
      </Tooltip>
    );
  } else {
    return (
      <Inpt
        error={error}
        //increase internal padding
        styles={{
          input: {
            padding: { padding },
          },
          ...styles,
        }}
        ref={ref}
        readOnly={readOnly}
        color={color}
        description={description}
        pt={pt}
        component={component}
        mask={mask}
        value={value}
        onChange={onChange}
        type={type}
        mt={mt}
        placeholder={placeholder}
        label={label}
        disabled={disabled}
        icon={icon}
        iconWidth={iconWidth}
        invalid={invalid}
        multiline={multiline}
        pointer={pointer}
        radius={radius}
        required={required}
        rightSection={rightSection}
        size={size}
        onBlur={onBlur}
        variant={variant}
        withAsterisk={withAsterisk}
        onInput={onInput}
        p={p}
        m={m}
        onWheel={(e) => e.target.blur()}
        {...form?.getInputProps(validateName, {})}
        {...props}
      />
    );
  }
};

export default React.forwardRef(TextInput);
